import React from 'react';
import { useTranslation } from '../LanguageContext';

// eslint-disable-next-line no-useless-concat
const email = 'support' + '@' + 'inoroff.org';

function Contact({ open, onClose }) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff',
          borderRadius: '12px',
          maxWidth: '400px',
          width: '100%',
          padding: '28px 24px 24px',
          position: 'relative',
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '14px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '22px',
            cursor: 'pointer',
            color: '#888',
            lineHeight: 1,
            padding: 0,
          }}
        >
          &times;
        </button>

        <h3 style={{ margin: '0 0 12px', color: '#6b0f3a', fontSize: '20px' }}>
          {t('contact.title')}
        </h3>

        <p style={{ margin: '0 0 16px', fontSize: '14px', color: '#555', lineHeight: '1.6' }}>
          {t('contact.text')}
        </p>

        <a
          href={'mailto:' + email}
          style={{
            display: 'inline-block',
            fontSize: '15px',
            fontWeight: '600',
            color: '#6b0f3a',
            wordBreak: 'break-all',
          }}
        >
          {email}
        </a>
      </div>
    </div>
  );
}

export default Contact;
